import React, { memo } from 'react';
import {
	useAdjustmentsEnabled,
	isFieldTypeSupported,
} from '@atlassian/ui-modifications-core/controllers';
import { GIC_VIEW_TYPE } from '../../common/constants/index.tsx';
import { EnabledFieldDecorator } from './enabled-field-decorator/index.tsx';
import type {
	DecoratedField,
	EnabledFieldDecoratorProps,
} from './enabled-field-decorator/types.tsx';

export type ComponentProps = DecoratedField;
export type FieldDecoratorAsyncProps<T extends ComponentProps> = EnabledFieldDecoratorProps<T>;

const FieldDecoratorAsyncNoMemo = <T extends ComponentProps>({
	Component,
	componentProps,
}: FieldDecoratorAsyncProps<T>) => {
	const adjustmentsAreEnabled = useAdjustmentsEnabled();

	const undecoratedComponent = <Component {...componentProps} />;

	// Render FieldDecorator only when field type is supported
	// and adjustments are enabled
	if (isFieldTypeSupported(GIC_VIEW_TYPE, componentProps.fieldType) && adjustmentsAreEnabled) {
		return (
			<EnabledFieldDecorator
				// @ts-expect-error - TS2322 - Type 'ComponentType<T>' is not assignable to type 'ComponentType<DecoratedField>'.
				Component={Component}
				componentProps={componentProps}
			/>
		);
	}

	return undecoratedComponent;
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const FieldDecoratorAsync = memo(
	FieldDecoratorAsyncNoMemo,
) as typeof FieldDecoratorAsyncNoMemo;

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { DecoratedField } from './enabled-field-decorator/types';
